import { useCallback } from 'react'
import { create } from 'zustand'
import type { DocumentOption } from '@/components/search/DocumentFilterPicker'

interface DocumentFilterState {
  /** The chosen document per case id. In-memory, like the page's mode: it survives going from the
   * Research page to a type's list and back, and resets on a full reload. */
  byCase: Record<string, DocumentOption | null>
  setFilter(caseId: string, document: DocumentOption | null): void
}

const useDocumentFilterStore = create<DocumentFilterState>()(set => ({
  byCase: {},
  setFilter(caseId, document) {
    set(state => ({ byCase: { ...state.byCase, [caseId]: document } }))
  },
}))

/** Read + set the document the Research pages of a case are filtered to. Null shows the whole case. */
export function useDocumentFilter(
  caseId: string
): [DocumentOption | null, (document: DocumentOption | null) => void] {
  const document = useDocumentFilterStore(s => s.byCase[caseId] ?? null)
  const set = useDocumentFilterStore(s => s.setFilter)
  const setDocument = useCallback((next: DocumentOption | null) => set(caseId, next), [set, caseId])
  return [document, setDocument]
}
